import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Block, Tabs, ScannerInput } from '@uni-space/uni-components';
import { getBagPostalLabel, getParcelPostalLabel } from '../api';
import { useLabelPrinter } from '@shared/labels';

export enum LabelRepairTab {
  Parcels = 'Parcels',
  Bags = 'Bags',
}

export default function LabelRepair() {
  const { t, i18n } = useTranslation();
  const [tab, setTab] = useState<LabelRepairTab>(LabelRepairTab.Parcels);

  const { isLabelLoading, printLabelFromFetcher } = useLabelPrinter({
    errorTitle: t('common.systemError.title'),
    fallbackErrorMessage: t('common.systemError.desc'),
  });

  const inputLabel = useMemo(() => {
    return tab === LabelRepairTab.Bags ? t('labelRepair.scanner.bagNumber') : t('labelRepair.scanner.trackNumber');
  }, [t, tab]);

  const handleSubmit = async (value: string) => {
    if (tab === LabelRepairTab.Bags) {
      await printLabelFromFetcher(() => getBagPostalLabel(value));
      return;
    }

    await printLabelFromFetcher(() => getParcelPostalLabel(value));
  };

  return (
    <Block mH={8}>
      <Block sx={{ maxWidth: 700, flex: 1, marginBottom: 8 }}>
        <Tabs
          value={tab}
          onChange={(id) => setTab(id as LabelRepairTab)}
          items={[
            { id: String(LabelRepairTab.Parcels), label: t('labelRepair.tabs.parcels') },
            { id: String(LabelRepairTab.Bags), label: t('labelRepair.tabs.bags') },
          ]}
        />
      </Block>
      <ScannerInput
        lang={i18n.language}
        label={inputLabel}
        buttonLabel={t('send')}
        isLoading={isLabelLoading}
        disabled={isLabelLoading}
        onSubmit={handleSubmit}
      />
    </Block>
  );
}
